<template>
  <div id="app" v-cloak>
    <!-- <router-view /> -->
    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {}
  },
  methods: {},
  created() {},
  mounted() {
    // window.addEventListener('beforeunload', (e) => {
    //   let message = '关闭提示'
    //   e = e || window.event
    //   if (e) {
    //     e.returnValue = message
    //   }
    //   if ((event.clientX > document.body.clientWidth && event.clientY < 0) || event.altKey) {
    //     alert('你关闭了浏览器')
    //     // return message
    //   } else if (event.clientY > document.body.clientHeight || event.altKey) {
    //     alert('你关闭了浏览器')
    //   } else {
    //     alert('你正在刷新页面')
    //   }
    //   // localStorage.removeItem('closetest')
    //   // localStorage.setItem('closetest', 'test')
    // })
    window.addEventListener(
      'hashchange',
      () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      },
      false
    )
  },
}
</script>
<style lang="less">
.table-sticky {
  .ivu-table {
    overflow: visible;
  }
  .ivu-table-header {
    position: sticky;
    top: 0px;
  }
}
</style>
<style lang="css">
[v-cloak] {
  display: 'none';
}
html {
  min-width: 1200px;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0px;
}
#app {
  background: #f8f8f9;
}
#app .menu-disabled {
  /* cursor: not-allowed!important; */
  opacity: 0.6;
}
/* 旋转动画 */
.loading-load-c {
  animation: myfirst 1s linear infinite;
}

@keyframes myfirst {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.ivu-tooltip-inner {
  white-space: pre-wrap !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue